import { render, staticRenderFns } from "./andSingle.vue?vue&type=template&id=311acc3e&scoped=true&"
import script from "./andSingle.vue?vue&type=script&lang=js&"
export * from "./andSingle.vue?vue&type=script&lang=js&"
import style0 from "./andSingle.vue?vue&type=style&index=0&id=311acc3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311acc3e",
  null
  
)

export default component.exports